
<template>
     <a-select show-search :value="value" placeholder="输入分支"  allow-clear style="width: 150px"
         @change="handleChange">
         <a-select-option v-for="d in data" :key="d.value">
             {{ d.label }}
         </a-select-option>
     </a-select>
</template>
<script>
export default {
    data() {
        return {
            data: [],
            searchTimmer:null,
            value:undefined
        }
    },

    methods: {
        setInputVal(val){
            this.value = val
        },
        handleChange(value) {
            this.value = value;
            this.$emit('onBranchChange',value);
        },
       
        initSelecter() {
            let that = this
            let params = {
                urlparams:false
            };
            that.$store.dispatch({
                type: 'branch/getallbranches',
                params:params
            }).then((res)=>{
                if(res.status == 200){
                    that.data = res.data
                }
                else{
                    that.data = []
                }
            })

        },
    },
    mounted(){
        this.initSelecter()
    }
   
};
</script>

<style scoped>

</style>
